import { CATALOG_STREAMS } from '@/data/catalog'
import { nodeCount } from './layers'

export type ExpandSummary = {
  id: string
  /** Stream / group id shown under the expanded band. */
  label: string
  /** Active stream total (caption / aria). */
  count: number
  /** Studio code under the band. */
  studioCode: string
  /** Studio display name when known. */
  studioName: string
  /** Game code (secondary caption). */
  gameCode: string
}

type TickMeta = {
  kind?: string
  streamId?: string
  value?: string
  studio?: string | null
  game?: string | null
  studioCode?: string | null
  gameCode?: string | null
  totalStreams?: number
}

const STUDIO_BY_STREAM = new Map<string, string>()
const GAME_BY_STREAM = new Map<string, string>()
for (const s of CATALOG_STREAMS) {
  const key = s.streamKey.trim().toUpperCase()
  if (s.studioCode) STUDIO_BY_STREAM.set(key, s.studioCode)
  if (s.gameCode) GAME_BY_STREAM.set(key, s.gameCode)
}

function studioGameFromTick(tick: unknown, fallbackId: string): { studioCode: string; gameCode: string } {
  const t = tick as TickMeta | null | undefined
  const streamKey = String(t?.streamId ?? t?.value ?? fallbackId).trim().toUpperCase()
  const studio =
    (typeof t?.studio === 'string' && t.studio.trim()) ||
    (typeof t?.studioCode === 'string' && t.studioCode.trim()) ||
    STUDIO_BY_STREAM.get(streamKey) ||
    ''
  const game =
    (typeof t?.game === 'string' && t.game.trim()) ||
    (typeof t?.gameCode === 'string' && t.gameCode.trim()) ||
    GAME_BY_STREAM.get(streamKey) ||
    ''
  return { studioCode: studio || '—', gameCode: game || '—' }
}

/** Identity strip for the expanded hex band (metrics come from layersFromTick). */
export function expandSummaryFromItem(
  item: { id: string; label: string; tick: unknown },
  studioNames?: Map<string, string>,
): ExpandSummary {
  const count = nodeCount(item.tick)
  const { studioCode, gameCode } = studioGameFromTick(item.tick, item.id)
  const studioName =
    (studioCode !== '—' && studioNames?.get(studioCode)) ||
    (studioCode !== '—' ? studioCode : '')

  return {
    id: item.id,
    label: item.label,
    count,
    studioCode,
    studioName,
    gameCode,
  }
}
